import { Environment } from "@webapp/util/Environment"

export async function getSyncAppInfoAsync() {
    const baseUrl = Environment.get('SYNC_APP_BASE_URL')
    const response = await fetch(`${baseUrl}/updates.json`)
    const updates = await response.json() as UpdatesInfo
    return {
        latestVersion: updates.latestVersion,
        requiredVersion: updates.requiredVersion,
        downloadUrls: {
            windows: `${baseUrl}/windows/TreeCrossingSync_${updates.latestVersion}_x64_en-US.msi`,
            mac: `${baseUrl}/mac/TreeCrossingSync_${updates.latestVersion}_x86_64.dmg`,
        },
        storeUrls: {
            windows: "ms-windows-store://pdp?ocid=pdpshare&hl=en-us&gl=us&productid=9P50KNCSGK41",
            // not in mac store
            other: "https://www.microsoft.com/store/productId/9P50KNCSGK41?ocid=pdpshare"
        }
    }
}

interface UpdatesInfo {
    latestVersion: string
    requiredVersion: string
}

export interface SyncAppInfo {
    latestVersion: string
    requiredVersion: string
    downloadUrls: {
        windows: string
        mac: string
    }
    storeUrls: {
        windows: string
        other: string
    }
}
